// extracted by mini-css-extract-plugin
module.exports = {"root":"PricingPanel_root__M6CtY","loading":"PricingPanel_loading__G_q4m"};